module.exports = __webpack_public_path__ + "img/findmykit-lifestyle-4.d2222913.png";